import uniq from 'lodash/uniq';

export const state = () => ({
  breadcrumbs: null,
  constants: null,
  dynamicBreadcrumbs: null,
  feefo: null,
  formStep: null,
  formSteps: null,
  head: null,
  jumbotron: null,
  meta: {},
  processingCarInsuranceOrder: false,
  quoteRef: null,
  structuredBreadcrumbs: null
});

export const mutations = {
  clear (state) {
    state.breadcrumbs = null;
    state.dynamicBreadcrumbs = null;
    state.head = null;
    state.jumbotron = null;
    state.meta = {};
    state.quoteRef = null;
  },
  setBreadcrumbs (state, crumbs) {
    state.breadcrumbs = crumbs;
  },
  SET_DYNAMIC_BREADCRUMBS (state, crumbs) {
    state.dynamicBreadcrumbs = crumbs;
  },
  setFeefo (state, feefo) {
    state.feefo = feefo;
  },
  setFormStep (state, step) {
    state.formStep = step;
  },
  setFormSteps (state, steps) {
    state.formSteps = steps;
  },
  setHead (state, head) {
    head.link = uniq((head.link || []).concat(
      [
        { href: '/favicon.ico', rel: 'icon', type: 'image/png' },
        { href: '/favicon-16x16.png', rel: 'icon', sizes: '16x16', type: 'image/png' },
        { href: '/favicon-32x32.png', rel: 'icon', sizes: '32x32', type: 'image/png' },
        { href: '/apple-touch-icon.png', rel: 'apple-touch-icon', sizes: '180x180', type: 'image/png' }
      ]
    ));
    if (head.structuredData) {
      const oldScript = (state.head && state.head.script) ? state.head.script : [];
      head.script = [...oldScript, ...head.script];
    }
    state.head = {
      ...state.head,
      ...head
    };
  },
  setJumbotron (state, jumbo) {
    state.jumbotron = jumbo;
  },
  SET_META (state, meta) {
    state.meta = { ...state.meta, ...meta };
  },
  SET_QUOTE_REF (state, quoteRef) {
    state.quoteRef = quoteRef;
  },
  setProcessingCarInsuranceOrder (state, processing) {
    state.processingCarInsuranceOrder = processing;
  },
  setStructuredBreadcrumbs (state, crumbs) {
    state.structuredBreadcrumbs = crumbs;
  }
};

export const getters = {
  getBreadcrumbs (state) {
    return uniq(state.breadcrumbs);
  },

  getDynamicBreadcrumbs (state) {
    return state.dynamicBreadcrumbs;
  },

  getFeefo (state) {
    return state.feefo;
  },

  getFormStep (state) {
    return state.formStep;
  },

  getFormSteps (state) {
    return state.formSteps;
  },

  getHead (state) {
    return state.head;
  },
  getJumbotron (state) {
    return state.jumbotron;
  },
  getMeta (state) {
    return state.meta;
  },
  getProcessingCarInsuranceOrder (state) {
    return state.processingCarInsuranceOrder;
  },
  getQuoteRef (state) {
    return state.quoteRef;
  },
  getStructuredBreadcrumbs (state) {
    const itemListElement = state.structuredBreadcrumbs;
    if (itemListElement) {
      return { '@context': 'http://schema.org', '@type': 'BreadcrumbList', itemListElement };
    }
    return null;
  }
};
